import React, {useContext} from 'react';
import {StoreContext} from "../../store.context";
import styled from "styled-components";
import {observer} from "mobx-react";

const StyledLoader = styled.div`
    .progress-container {
        width: 100%;
        position: absolute;
        left: 250px;
        right: 0;
        bottom: 0;
    }

    .progress-bar {
        height: 4px;
        background-color: rgba(209, 227, 48, 0.2);
        width: 100%;
        overflow: hidden;
    }

    .progress-bar-value {
        width: 100%;
        height: 100%;
        background-color: #d1e330;
        animation: indeterminateAnimation 1s infinite linear;
        transform-origin: 0 50%;
    }

    @keyframes indeterminateAnimation {
        0% {
            transform: translateX(0) scaleX(0);
        }
        40% {
            transform: translateX(0) scaleX(0.4);
        }
        100% {
            transform: translateX(100%) scaleX(0.5);
        }
    }
`;

export const ProcessLoader: React.FC = observer(() => {
    const { appStore: { loading } } = useContext(StoreContext);

    return (
        <StyledLoader>
            <div className="progress-container" style={{ display: ( loading ? 'block' : 'none')}}>
                <div className="progress-bar">
                    <div className="progress-bar-value"></div>
                </div>
            </div>
        </StyledLoader>
    );
});
